module.exports = __webpack_public_path__ + "img/zfr3.3052a122.jpg";